import { isNullOrUndefined } from 'is-what';
import { INavItem } from '../models/INavItem';

export const NavItemHelper = {
    linkHasChildren: (navitem: INavItem) => !isNullOrUndefined(navitem) && !isNullOrUndefined(navitem.children) && navitem.children.length > 0,
    isExternalLink: (navitem: INavItem) => !isNullOrUndefined(navitem) && !isNullOrUndefined(navitem.url),
    isLinkAllowed: (userRoles: string[], navitem: INavItem) => userRoles.some(r => navitem.visibility.map(x => x.toLowerCase()).includes(r.toLowerCase()))
}
